import { Button, Container, Row, Spinner } from "react-bootstrap";
import { Form, Input } from "antd";
import { useCallback, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import TextArea from "antd/es/input/TextArea";
import { User } from "../api/User";
import { useToasts } from "../contexts/toasts";

const formLayout = {
  labelCol: {
    xs: 24,
    md: 24,
  },
};

export default function SupportForm() {
  const [form] = Form.useForm();
  const { showToast } = useToasts();
  const [loading, setLoading] = useState(false);

  const handleFormSubmit = useCallback((values: any) => {
    setLoading(true);
    User.sendEmail({
      sender: values.sender,
      name: values.name,
      receiver: "support@getmoveapp.com",
      title: values.title,
      text: values.text,
    }).then(
      () => {
        showToast(
          "mail-success",
          "Grazie per il tuo feedback, ti risponderemo quanto prima",
          "Email Send Success",
          "success"
        );
        setLoading(false);
      },
      () => {
        showToast(
          "mail-error",
          "Errore nell'invio della mail, per favore riprova",
          "Email Send Error",
          "danger"
        );
        setLoading(false);
      }
    );
  }, [showToast]);

  return (
    <Container
      fluid
      className="d-flex flex-column gap-3 py-5 justify-content-center text-align-center align-items-center"
    >
      <h2 className="text-center mb-4">Contattaci</h2>
      <Form {...formLayout} form={form} onFinish={handleFormSubmit}>
        <Row className="mb-3">
          <Form.Item
            labelAlign="left"
            name="name"
            label="Nome"
            rules={[
              {
                required: true,
                message: "Devi inserire il tuo nome",
              },
            ]}
          >
            <Input size="large" placeholder="Inserisci il tuo nome..." />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            name="sender"
            label="Email"
            rules={[
              {
                required: true,
                message: "Devi inserire la tua email",
              },
              {
                type: "email",
                message: "Devi inserire un campo email valido",
              },
            ]}
          >
            <Input size="large" placeholder="Inserisci un indirizzo mail..." />
          </Form.Item>
        </Row>
        <Row className="mb-3">
          <Form.Item
            labelAlign="left"
            name="title"
            label="Titolo"
            rules={[
              {
                required: true,
                message: "Devi inserire un titolo per la tua segnalazione",
              },
            ]}
          >
            <Input size="large" placeholder="Inserisci un titolo..." />
          </Form.Item>
        </Row>
        <Row className="mb-3">
          <Form.Item
            labelAlign="left"
            name="text"
            label="Testo"
            rules={[
              {
                required: true,
                message: "Devi inserire un testo per la tua segnalazione",
              },
            ]}
          >
            <TextArea cols={24} rows={5} placeholder="Inserisci testo" />
          </Form.Item>
        </Row>
        <Button type="submit" variant="success" disabled={loading}>
          {loading ? (
            <Spinner size="sm" />
          ) : (
            <FontAwesomeIcon icon={faCheckCircle} />
          )}
          <span className="ms-2">Invia</span>
        </Button>
      </Form>
    </Container>
  );
}
